















































import { Validator } from 'vee-validate'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Inject, Prop } from 'vue-property-decorator'

import { PluginMixin } from '@spa/mixins/plugin'
import { PhoneticNameFormState } from './phoneticNameFormState'

@Component
export default class NameForm extends Mixins<PluginMixin>(PluginMixin) {
  @Inject()
  $validator: Validator

  @Prop({ default: '' })
  phoneticFirstName: string

  @Prop({ default: '' })
  phoneticLastName: string

  @Prop({ required: true })
  handleFormUpdated: (val: PhoneticNameFormState) => void

  @Prop({ default: false })
  isRequired: boolean

  @Prop({ default: '' })
  namePrefix: string

  get formState(): PhoneticNameFormState {
    return {
      phoneticFirstName: this.phoneticFirstName,
      phoneticLastName: this.phoneticLastName,
    }
  }

  get hasExtendedValidationError(): boolean {
    return !!this.$slots.extendedValidationErrorMessage
  }

  get validation(): any {
    return {
      required: this.isRequired,
      max: 10,
      regex: /^([ァ-ヴ][ァ-ヴー・]*)$/,
      unusable_emoji: true,
      unusable_character: true,
      contains_tab: true,
    }
  }

  nameWithPrefix(name: string) {
    return !!this.namePrefix ? `${this.namePrefix}-${name}` : name
  }

  handleInputPhoneticFirstName(input: string): void {
    this.handleFormUpdated({
      ...this.formState,
      phoneticFirstName: input,
    })
  }

  handleInputPhoneticLastName(input: string): void {
    this.handleFormUpdated({
      ...this.formState,
      phoneticLastName: input,
    })
  }
}
